import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { CommandPanels, withBaseEditor } from '../../BaseEditor';

function LocalityEditor({ getControl, data }) {
  const districtFilter = useMemo(
    () => ({ province: data.province && data.province.id }),
    [data.province],
  );
  return (
    <Grid container spacing={2}>
      <Grid item sm={4}>
        {getControl('locality_type')}
      </Grid>
      <Grid item sm={8}>
        {getControl('name')}
      </Grid>
      <Grid item sm={6}>
        {getControl('koatuu')}
      </Grid>
      <Grid item sm={6}>
        {getControl('katottg')}
      </Grid>
      <Grid item sm={4}>
        {getControl('province')}
      </Grid>
      <Grid item sm={4}>
        {getControl('district', { filter: districtFilter })}
      </Grid>
      <Grid item sm={4}>
        {getControl('region', { backend: '/api/catalog/regions/' })}
      </Grid>
      <Grid item sm={4}>
        {getControl('is_capital')}
      </Grid>
    </Grid>
  );
}

LocalityEditor.propTypes = {
  getControl: PropTypes.func.isRequired,
  data: PropTypes.shape({
    province: PropTypes.shape({
      id: PropTypes.number,
      repr: PropTypes.string,
    }),
  }).isRequired,
};
export default withBaseEditor(LocalityEditor, '/api/catalog/localities/', CommandPanels.catCommandPanel);
